import React, { useState } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CardWrapper, TabNavigation } from "../ui";
import ConvertScannerTab from "./converts_scanner/ConvertScannerTab";
import DataManagementTab from "./converts_scanner/DataManagementTab";
import SummaryTab from "./converts_scanner/ConvertSummaryTab";
import SecurityDataTab from "./converts_scanner/ConvertSecurityDataTab";

const Convert_universe = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState("tab1");

  const tabs = [
    { value: "tab1", label: "Summary" },
    { value: "tab2", label: "Convert Scanner" },
    { value: "tab3", label: "Data Management" },
    { value: "tab4", label: "Conversion Ratio Data" },
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tab Navigation */}
      <CardWrapper sx={{ mb: 3 }}>
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabClick}
        />
      </CardWrapper>

      {/* Tab content */}
      <Box sx={{ backgroundColor: theme.palette.background.default }}>
        {activeTab === "tab1" && <SummaryTab />}
        {activeTab === "tab2" && <ConvertScannerTab />}
        {activeTab === "tab3" && <DataManagementTab />}
        {activeTab === "tab4" && <SecurityDataTab />}
      </Box>
    </Box>
  );
};

export default Convert_universe;
